import { NavLink, useParams } from "react-router-dom";
import FastImage from "../../../globals/elements/fastimg";
import { loadScript, route } from "../../../globals/constants";
import { useEffect, useState } from "react";
import { getGoodCategoryList, getGoodInfo } from "../../../utils/func";
import SEO from '../../components/seo'
function ShopProductDetailPage({ siteName,pageTitle }) {

  

    const [info, setInfo] = useState(null)
    const [description,setDescription] = useState('')
    const [images,setImages] = useState([])
    const [specList,setSpecList] = useState([])
    const [categoryList,setCategoryList] = useState([])
    const [body,setBody] = useState([])
    const params = useParams()
    console.log("14 params is", params)
    // const id = params.id;
    useEffect(() => {
        loadInfo(params.id)
    }, [params])

    function loadInfo(id) {
        console.log("23 load info is", id)
        getGoodInfo(id).then(result => {
            console.log("good info result is", result)
            const info = result[0]
            setInfo(info)
            loadDescription(info?.description)
            setImages(JSON.parse(info.images))
            setSpecList(JSON.parse(info.spec_list))
            setBody(JSON.parse(info.body))
            loadCategoryList(JSON.parse(info?.category_ids))
        }).catch(err => {

        })
    }

    function loadDescription(descriptionTxt) 
    {
        var rawFile = new XMLHttpRequest();
        rawFile.open("GET", descriptionTxt, false);
        rawFile.onreadystatechange = () => {
            if (rawFile.readyState === 4) {
                if (rawFile.status === 200 || rawFile.status == 0) {
                    var allText = rawFile.responseText;
                    console.log("allText: ", allText);
                   
                    setDescription(allText)
                }
            }
        };
        rawFile.send(null);
    }

    function loadCategoryList(category_ids)
    {
        getGoodCategoryList(category_ids).then(result =>{
            setCategoryList(result)
        }).catch(err => {

        })
    }

    useEffect(()=>{
        loadScript("js/custom.js")
        loadScript("js/product-details.js")
    })

    const keywords = categoryList && categoryList.length > 0 && categoryList.map(c => c.name).toString()

    console.log('spec list is', specList)

    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={`${pageTitle} | ${info?.title}`}
                description={info?.description}
                keywords={keywords }
            />
            {/* Product Detail */}
            <div className="section-full p-t80 p-b50">
                <div className="container woo-entry">
                    <div className="row m-b30">
                        <div className="col-md-4 col-sm-4  m-b30">
                          
                            <div className="mt-box mt-product-gallery on-show-slider">
                                <div id="sync1" className="owl-carousel owl-theme owl-btn-vertical-center m-b5">
                                { images.length > 0 ? (
                                        <div className="item">
                                            <div className="mfp-gallery">
                                                <div className="mt-box">
                                                    <div className="mt-thum-bx mt-img-overlay1 ">
                                                        <FastImage src={images[0]} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <a className="mfp-link" href={images[0]}>
                                                                    <i className="fa fa-search mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     ) : <div className="item"></div>
                                   }

                                   { images.length > 1 ? (
                                        <div className="item">
                                            <div className="mfp-gallery">
                                                <div className="mt-box">
                                                    <div className="mt-thum-bx mt-img-overlay1 ">
                                                        <FastImage src={images[1]} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <a className="mfp-link" href={images[1]}>
                                                                    <i className="fa fa-search mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     ) : <div className="item"></div>
                                   }

                                    { images.length > 2 ? (
                                        <div className="item">
                                            <div className="mfp-gallery">
                                                <div className="mt-box">
                                                    <div className="mt-thum-bx mt-img-overlay1 ">
                                                        <FastImage src={images[2]} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <a className="mfp-link" href={images[2]}>
                                                                    <i className="fa fa-search mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     ) : <div className="item"></div>
                                   }

                                    { images.length > 3 ? (
                                        <div className="item">
                                            <div className="mfp-gallery">
                                                <div className="mt-box">
                                                    <div className="mt-thum-bx mt-img-overlay1 ">
                                                        <FastImage src={images[3]} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <a className="mfp-link" href={images[3]}>
                                                                    <i className="fa fa-search mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     ) : <div className="item"></div>
                                   }

                                    { images.length > 4 ? (
                                        <div className="item">
                                            <div className="mfp-gallery">
                                                <div className="mt-box">
                                                    <div className="mt-thum-bx mt-img-overlay1 ">
                                                        <FastImage src={images[4]} alt="" />
                                                        <div className="overlay-bx">
                                                            <div className="overlay-icon">
                                                                <a className="mfp-link" href={images[4]}>
                                                                    <i className="fa fa-search mt-icon-box-xs" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     ) : <div className="item"></div>
                                   }
                                   
                                </div>
                                <div id="sync2" className="owl-carousel owl-theme">
                                    {
                                        images.length > 0 ? (
                                            <div className="item">
                                                <div className="mt-media">
                                                    <FastImage src={images[0]} alt="" />
                                                </div>
                                            </div>
                                        ) : <div className="item"></div>
                                    }
                                    
                                    {
                                        images.length > 1 ? (
                                            <div className="item">
                                                <div className="mt-media">
                                                    <FastImage src={images[1]} alt="" />
                                                </div>
                                            </div>
                                        ) : <div className="item"></div>
                                    }

                                    {
                                        images.length > 2 ? (
                                            <div className="item">
                                                <div className="mt-media">
                                                    <FastImage src={images[2]} alt="" />
                                                </div>
                                            </div>
                                        ) : <div className="item"></div>
                                    }

                                    {
                                        images.length > 3 ? (
                                            <div className="item">
                                                <div className="mt-media">
                                                    <FastImage src={images[3]} alt="" />
                                                </div>
                                            </div>
                                        ) : <div className="item"></div>
                                    }

                                    {
                                        images.length > 4 ? (
                                            <div className="item">
                                                <div className="mt-media">
                                                    <FastImage src={images[4]} alt="" />
                                                </div>
                                            </div>
                                        ) : <div className="item"></div>
                                    }
                                   
                                </div> 
                            </div>
                        </div> 
                        <div className="col-md-8 col-sm-8">
                            <div className="mt-post-title ">
                                <h3 className="post-title">{info?.title}</h3>
                            </div>
                            
                            <div className="mt-post-text">
                                <p className="m-b10">{description?.substring(0, description?.indexOf("。")+ 1)}</p>
                            </div>
                          
                            <div className="product_meta">

                                <span className="posted_in">Category: &nbsp;
                                    {
                                        categoryList && categoryList.length > 0 && categoryList.map((category,index) => {
                                            return (
                                                <NavLink key={`link-${index}`} to={route.services.SERVICES} rel="tag">{`${category.name} `}</NavLink>
                                            )
                                        })
                                    }

                                </span>
                            </div> 
                        </div>
                    </div>
                    {/* TABS CONTENT START */}
                    <div className="row m-b30">
                        <div className="col-md-12 p-b30">
                            <div className="mt-box m-30">
                                <p>{description}</p>
                            </div>
                            <table className="table m-b30 no-border">
                                <tbody>
                                    {
                                        specList && specList.length > 0 && specList.map((spec,index) => {
                                            return (
                                                <tr key={`tr-i${index}`}>
                                                    <td><b>{spec?.name}</b></td>
                                                    <td>{spec?.value_list?.map((sp,idx) => sp?.name).toString()}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    
                                </tbody></table>
                            
                        </div>
                    </div>

                    <div className="section-head  text-center">
                        {
                            body && body.length > 0 && body.map((b,index) => {
                                if(b.type === "image") {
                                    return <FastImage src={b.value.url} key={`image-${index}`} />
                                }
                            })
                        }
                    </div>

                    
                </div> 
            </div>

        </>
    )
}
export default ShopProductDetailPage;